import React, { Component } from 'react'
import { parseQuery } from '../helpers/query'
import styles from '../styles/search-input.module.css'

export class SearchInput extends Component {
  constructor (props) {
    super(props)

    // Get query string to populate initial input value
    const query = parseQuery(window.location.search)

    this.state = {
      input: query.location ? query.location : ``
    }

    this.input = React.createRef()

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  
  handleInputChange (e) {
    this.props.enableSearch()

    this.setState({
      input: e.target.value,
    })
  }

  handleSubmit (e) {
    e.preventDefault()

    this.input.current.blur()
    
    if (this.state.input) {
      this.props.onSubmit(this.state.input)
    }
  }

  render () {
    return (
      <form className={styles['location-search-wrapper']} onSubmit={this.handleSubmit}>
        <div className={styles['location-search__current']}>
          <button type="button" className={styles['current-location-icon']} onClick={this.props.onIconClick} aria-label={this.props.lang === 'en' ? `current location` : `position actuelle`}>
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
          </button>
        </div>
        <input type="text" className={styles['location-search__input']} placeholder={this.props.placeholder} value={this.state.input} onChange={this.handleInputChange} ref={this.input} aria-label={this.props.lang === 'fr' ? `entrez la ville ou le code postal` : `enter city or postal code`}/>
        <button type="submit" className={styles['location-search__submit']} aria-label={this.props.lang === 'fr' ? `recherchez` : `search`}>{this.props.buttonText}</button>
      </form>
    )
  }
} 

export default SearchInput